// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyCBBc4f8ubyV3v672FuAVeDYasy1gv1InY",
    authDomain: "countdown-610c6.firebaseapp.com",
    projectId: "countdown-610c6",
    storageBucket: "countdown-610c6.appspot.com",
    messagingSenderId: "930777721330",
    appId: "1:930777721330:web:e9650f0adc8a91b6f4e36b",
    measurementId: "G-X95BEFKVHV"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
